// extracted by mini-css-extract-plugin
module.exports = {"lazy-loader-placeholder":"LazyLoader_lazy-loader-placeholder__3btL3"};